import React, { FC } from 'react';
import { PrismicGoogleMapsSlice } from '@modules/visits/model';
import SliceLayout from '@modules/visits/components/tag/slice/common/SliceLayout';
import * as Styled from './GoogleMapsSlice.styles';

interface GoogleMapsSliceProps {
  slice: PrismicGoogleMapsSlice;
}

const GoogleMapsSlice: FC<GoogleMapsSliceProps> = ({ slice }) => {
  const location = slice.primary.app_google_maps_location;
  
  if (!location?.latitude || !location?.longitude) {
    return null;
  }

  // Format: https://www.google.com/maps?q=latitude,longitude
  const googleMapsUrl = `https://www.google.com/maps?q=${location.latitude},${location.longitude}`;

  return (
    <SliceLayout title={slice.primary.app_google_maps_title}>
      <Styled.GoogleMapsSliceContainer>
        <a 
          href={googleMapsUrl} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <Styled.GoogleMapsIcon>📍</Styled.GoogleMapsIcon>
          <span>Voir sur Google Maps</span>
        </a>
      </Styled.GoogleMapsSliceContainer>
    </SliceLayout>
  );
};

export default GoogleMapsSlice;